/* stylelint-disable selector-max-compound-selectors */

$form-hero--pb: var(--form-hero--pb, 0);
$form-hero--curves-height: var(--form-hero--curves-height, auto);

:host {
  @include reset-host;
  @include reset-font-smoothing;
  @include reset-media;
  @include reset-text;
}

$mobile-bg-curve-height: 10vw;

:host .landing-hero {
  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 $gutter;

  overflow: hidden;

  background: $color-purple;

  @include mq('max', 'md') {
    padding: 0 $gutter-mobile;
  }

  .content {
    position: relative;

    max-width: rem(510);
    margin: 0 auto;
    padding: rem(56) 0 rem(150);

    @include mq('max', 'md') {
      padding: rem(52) 0 rem(354);
    }
  }

  .main-title {
    display: flex;
    width: 100%;
    margin-bottom: rem(26);
    padding: 0 $gutter;

    text-align: center;

    @include mq('max', 'md') {
      max-width: rem(277);
      margin: 0 auto;
      margin-bottom: rem(17);
      padding: 0 $gutter-mobile;
    }

    img {
      height: auto;
    }

    .text {
      display: inline-block;

      text-indent: -9999999999px;
    }
  }

  .text-wrapper {
    --paragraph-color: #{$white};
    text-align: center;
  }

  .ethi-visual {
    position: absolute;
    right: -70%;
    bottom: 0;

    @include mq('max', 'md') {
      right: -20%;
    }

    img {
      @include mq('max', 'md') {
        width: auto;
        max-height: rem(330);
      }
    }
  }

  .baseline {
    position: absolute;
    bottom: rem(40);
    left: rem(-220);

    color: $white;
    font-size: rem(36);
    font-family: $ff-title;
    line-height: 1.1;
    text-align: center;

    text-shadow: 2px 2px $color-purple;

    transform: rotate(-9deg);

    @include mq('max', 'md') {
      bottom: rem(190);
      left: rem(-50);

      max-width: rem(200);
    }
  }

  .curves {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;

    width: 106%;
    height: $form-hero--curves-height;
    margin-bottom: -1px;
    margin-left: -3%;

    color: $white;
    aspect-ratio: 1440 / 161;

    @include mq('max', 'md') {
      aspect-ratio: 228 / 22;
    }
  }

  .curve {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: auto;
  }
}
